import staticMixin from './staticMixin';

export default {
  props: ['value', 'model', 'lazy', 'borderless', 'disabled', 'title', 'disableTooltip', 'tooltip'],
  mixins: [staticMixin],
  data() {
    return {
      renderReady: false,
      isMouseOver: false
    };
  },

  computed: {
    svalue: {
      get() {
        //const mm = this.$model.$model;
        const vv = this.model.$value;
        // console.log("svalue.get()", this.model.$path, vv);
        if (this.localValue !== undefined) {
          // this.resize(this.localValue);
          return this.localValue;
        }
        // this.resize(vv);
        return vv;
      }
    },
    getTitle: {
      get() {
        if (this.title === undefined || this.title === null) {
          return this.model.$schema.title;
        }
        return this.title;
      }
    },
    tooltipVisibility: {
      get() {
        return !this.disableTooltip && this.isMouseOver && this.tooltipContent != undefined && this.tooltipContent != '';
      }
    },
    tooltipContent: {
      get() {
        if (this.disableTooltip) {
          return undefined;
        }

        return this.tooltip;
      }
    },
    isDisabled: {
      get() {
        return this.disabled || this.model.$schema.readOnly;
      }
    }
  },

  created() {
    // this.$model = this.model || this.value;
    //console.log(this);

    //jeśli podano przez s-model
    //let smodel = this.$attrs["s-model.lazy"];
    //if (smodel) {

    //}

    // jesli podano przez v-model lub :model

    if (this._props.lazy !== undefined) {
      //console.log('lazy', this._props.lazy);
      this.$options.lazy = this._props.lazy || this._props.lazy === '';
    }

    //console.log("created: "+this.model.$path);

    if (this.value) {
      //ustawiono przez vmodel
      this.$options.vmodel = true;

      this.setModel(this.value);
    } else {
      this.setModel(this.model);
    }

    //szukanie sekcji w któej jest umieszczony komponent
    /*
    if (this.$sectionName === undefined) {
      let parent = this.$parent;
      while (parent) {
        if (parent.$sectionName !== undefined) {
          this.$sectionName = parent.$sectionName;
          break;
        }
        parent = parent.$parent;
      }
    }
    */
  },
  watch: {
    lazy(newValue) {
      // console.log('superlazy', newValue);
      this.$options.lazy = newValue;
    },
    model(newValue) {
      //console.log('model change', newValue.$path);
      //this.setModel(newValue);
      //this.$refs.input.value = this.$model.$value;
    }
  },
  methods: {
    setModel(model, modifiers) {
      if (model) {
        //this.$model = model;
        //console.log('this.$model',this.model);
        const $form = model.$form;
        if ($form) {
          // this.$options.lazy = modifiers.lazy;
          if ($form.lazy !== undefined) {
            this.$options.lazy = $form.lazy;
            //this.lazy = $form.lazy;
          }
        }
        /*
        if (modifiers) {
          // this.$options.lazy = modifiers.lazy;
          if (modifiers.lazy !== undefined) {
            this.$options.lazy = modifiers.lazy;
          }
        }
        */
        this.renderReady = true;
      } else {
        this.$model = {};
      }
    },
    //abstract
    resize(newValue, blur) {
      return; //nic nie rób
    },
    onFocus(evt) {
      // lokalna kopia
      // console.log('model mixin focus');
      this.localValue = this.model.$value;
      this.enterValue = this.localValue;
      this.resize(this.localValue);
      // ustawienie e uytkownik jest w tym polu
      this.model.$hasFocus = true;
      this.$emit('focus', evt);
    },
    onBlur(evt) {
      // console.log("read",this.model.$value);

      if (this.$options.vmodel) {
        delete this.localValue;
        const newValue = this.model.$value;
        if (newValue !== this.enterValue) {
          this.$emit('change', newValue);
          this.fieldChanged();
        }
      } else {
        if (this.$options.lazy) {
          //if (this.lazy) {
          this.model.$value = this.localValue;
        }
        delete this.localValue;
        // this.localValue =  this.model.$value;
        const newValue = this.model.$value;
        if (this.$refs.input.value !== newValue) {
          this.$refs.input.value = newValue; // skopiowanie wartości z modelu przy wyjściu
          this.$emit('input', newValue);
        }
        if (newValue !== this.enterValue) {
          this.$emit('change', newValue);
          this.fieldChanged();
        }
      }
      // console.log('model mixin blur');
      this.$emit('blur', evt);
      this.model.$hasFocus = this.hasFocus = false;

      this.resize(undefined, true);

      // this.value = this.model.$value;
      // window.console.log("read",this.model.$value)
      // this.localValue = this.model.$value;
    },
    fieldChanged() {
      let parent = this.formParent;

      if (parent && parent.form.fieldsChanged) {
        if (!parent.form.fieldsChanged.includes(this.model.$key)) {
          parent.form.fieldsChanged.push(this.model.$key);
          parent.$emit('fieldchanged', this.model.$key);
        }
      }
    },
    onInput(evt) {
      if (evt.target.composing) {
        return;
      }
      // if (this.lazy) return;
      const newValue = evt.target.value;
      if (newValue !== this.localValue) {
        this.resize(newValue);
        this.localValue = newValue;
        if (!this.$options.vmodel) {
          if (this.$options.lazy) {
            //if (this.lazy) {
            return;
          }
          this.model.$value = newValue;
        }
        this.$emit('input', newValue);
      }

      // this.model.$value = this.$refs.input.value;
    },
    mouseOver(evt) {
      // console.log('mouseover');
      // this.$set(this, 'isMouseOver', true);
    },
    mouseOut(evt) {
      // console.log('mouseout');
      // this.$set(this, 'isMouseOver', false);
    }
  }
};
